import React from 'react';

export default function ReLoading() {

  return (<div />);
}